import React from 'react';
import Revision from "components/brief/reviewer/revision/Revision";
import "styles/css/agent/Quoting.css";

const PortalProposedView = ({
  flow,
  revisionId,
  revisionContent,
  revisionDetails,
  currentAuthor,
  onUpdate
}) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center p-0 p-md-3"
      style={{
        position: "fixed",
        width: "97%",
        height: "95%",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }}
    >
      <div
        className="w-100 shadow-2xl overflow-hidden animate__animated animate__fadeInUp">
        <Revision
          flow={flow}
          revisionId={revisionId}
          hideMainTabs={true}
          showAdditionalCommentButton={true}
          content={revisionContent}
          currentAuthor={currentAuthor}
          prevContent={revisionDetails}
          onUpdate={onUpdate}
        />
      </div>
    </div>
  );
}

export default PortalProposedView;